import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import { Checkbox } from '@els/els-react--checkbox';

export default function ThesaurusItemCheckboxInfo(props) {
  const { item, title, selected, onClickThesaurusItem } = props;

  return (
    <Checkbox
      data-e2e={`thesaurus-item-checkbox-${title}`}
      className="tree-view-dialog-thesaurus-item-info-checkbox"
      size="small"
      onChange={() => {
        onClickThesaurusItem(item);
      }}
      checked={selected}
      label={title}
      title={title}
    />
  );
}

ThesaurusItemCheckboxInfo.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  title: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};
